<div class="flex flex-col custom-table gap-1">
  <ngx-datatable [rows]="data" [count]="data.length" default>
    <ngx-datatable-column
      [sortable]="false"
      class="bg-gray-30"
      name="{{ 'ServicingService::EventType' | abpLocalization }}"
      prop="inspectionName"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row.inspectionName }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      name="{{ 'ServicingService::Date' | abpLocalization }}"
      prop="date"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row.date | date }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      name="{{ 'ServicingService::Cost' | abpLocalization }}"
      prop="inspectionCost"
      [sortable]="false"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row.inspectionCost }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [sortable]="false"
      name="{{ 'ServicingService::Operator' | abpLocalization }}"
      prop="operator"
      [width]="120"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row.operator }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false">
      <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
        <div class="flex justify-end items-center">
          <button type="button" class="btn btn-light btn-sm details-button" (click)="onView(row)">
            <i class="fa fa-info me-1" aria-hidden="true"></i>
            {{ 'AbpUi::Details' | abpLocalization }}
          </button>
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
